import {
  Box,
  Button,
  Container,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Grid,
  TextField,
} from "@mui/material";
import React, { useEffect } from "react";
import ContentPage from "../Components/ContentPage";
import HomeIcon from "@mui/icons-material/Home";
import ManageAccountsTwoToneIcon from "@mui/icons-material/ManageAccountsTwoTone";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import DeleteSweepTwoToneIcon from "@mui/icons-material/DeleteSweepTwoTone";
import DataTable from "../Components/Table/DataTable";
import { useDispatch, useSelector } from "react-redux";
import {
  departmentDetailCreate,
  departmentDetailDelete,
  departmentDetailList,
  departmentDetailUpdate,
} from "../store/Slice/departmentDetailSlice";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import SaveAltIcon from "@mui/icons-material/SaveAlt";

export default function DepartmentList() {
  const dispatch = useDispatch();
  const departmentDetail = useSelector(
    ({ departmentDetail }) => departmentDetail
  );
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    dispatch(departmentDetailList());
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      flag: "create",
      department_detail_id: "",
      department_detail_name: "",
    },
    validationSchema: Yup.object().shape({
      department_detail_id: Yup.string().required("ระบุ ID"),
      department_detail_name: Yup.string().required("ระบุจุดตรวจ"),
    }),
    onSubmit: (values) => {
      if (values.flag === "create") {
        dispatch(departmentDetailCreate(values)).then(() => {
          dispatch(departmentDetailList());
          handleClose();
        });
      } else {
        dispatch(departmentDetailUpdate(values)).then(() => {
          dispatch(departmentDetailList());
          handleClose();
        });
      }
    },
  });
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };
  const handleClickEdit = (data) => {
    formik.setFieldValue("flag", "edit");
    formik.setFieldValue("department_detail_id", data.department_detail_id);
    formik.setFieldValue("department_detail_name", data.department_detail_name);
    setOpen(true);
  };
  const rows = departmentDetail.result;
  const columns = [
    {
      field: "#",
      headerName: "#",
      width: 30,
    },
    {
      field: "department_detail_id",
      headerName: "ID",
    },
    {
      field: "department_detail_name",
      headerName: "จุดตรวจ",
    },
    {
      field: "actions",
      headerName: "Actions",
      numeric: "center",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              startIcon={<EditTwoToneIcon />}
              sx={{ mr: 2 }}
              onClick={() => handleClickEdit(row)}
            >
              แก้ไข
            </Button>
            <Button
              variant="contained"
              startIcon={<DeleteSweepTwoToneIcon />}
              color="error"
              onClick={() => {
                Swal.fire({
                  title: "คุณต้องการลบข้อมูลหรือไม่",
                  text: row.department_detail_name,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#FF8C00",
                  cancelButtonColor: "#FF4500",
                  confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ยกเลิก",
                  customClass: {
                    title: "sweetalert-title", // Apply Sarabun font to the title
                    content: "sweetalert-content", // Apply Sarabun font to the content
                    confirmButton: "sweetalert-confirm-button",
                    cancelButton: "sweetalert-cancel-button",
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    dispatch(
                      departmentDetailDelete({
                        department_detail_id: row.department_detail_id,
                      })
                    ).then(() => {
                      dispatch(departmentDetailList());
                    });
                    Swal.fire({
                      title: "ลบ!",
                      text: "ลบข้อมูลเรียบร้อย",
                      icon: "success",
                    });
                  }
                });
              }}
            >
              ลบ
            </Button>
          </Box>
        );
      },
    },
  ];
  return (
    <Container maxWidth={"xl"}>
      <ContentPage
        image_icon={process.env.PUBLIC_URL + "/icons/test.png"}
        title="จุดตรวจ"
        TitlePageMenulist={[
          {
            label: "หน้าแรก",
            href: "/lab",
            icon: <HomeIcon fontSize="small" />,
          },
          {
            label: "Data Master",
            href: "#",
            icon: <ManageAccountsTwoToneIcon fontSize="small" />,
          },
          {
            label: "จุดตรวจ",
            href: "/lab/department",
            icon: <ManageAccountsTwoToneIcon fontSize="small" />,
          },
        ]}
        btnAction={
          <Button
            variant="contained"
            startIcon={<AddCircleTwoToneIcon />}
            onClick={handleClickOpen}
          >
            เพิ่มจุดตรวจ
          </Button>
        }
      >
        <Paper elevation={0} sx={{ p: 1 }}>
          <DataTable columns={columns} rows={rows} />
        </Paper>
      </ContentPage>
      <Dialog
        open={open}
        fullWidth
        maxWidth={"md"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        component={"form"}
        onSubmit={formik.handleSubmit}
      >
        <DialogTitle id="alert-dialog-title">
          {formik.values.flag === "edit" ? "แก้ไข" : "เพิ่ม"}จุดตรวจ
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            direction={"row"}
            justifyContent={"flex-start"}
            spacing={2}
            mt={1}
          >
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                id="department_detail_id"
                name="department_detail_id"
                value={formik.values.department_detail_id}
                label="ID"
                size="small"
                variant="outlined"
                onChange={formik.handleChange}
                error={Boolean(formik.errors.department_detail_id)}
                helperText={formik.errors.department_detail_id}
                disabled={formik.values.flag === "edit"}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                id="department_detail_name"
                name="department_detail_name"
                value={formik.values.department_detail_name}
                label="จุดตรวจ"
                size="small"
                variant="outlined"
                onChange={formik.handleChange}
                error={Boolean(formik.errors.department_detail_name)}
                helperText={formik.errors.department_detail_name}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleClose}
            color="error"
            startIcon={<CloseIcon />}
          >
            ปิด
          </Button>
          <Button
            variant="contained"
            type="submit"
            autoFocus
            startIcon={<SaveAltIcon />}
          >
            {formik.values.flag === "edit" ? "อัพเดท" : "บันทึก"}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
